// 处理混合模式下的购物车图标点击事件
// 当cart_type为notification时，仍然让购物车图标打开抽屉
document.addEventListener('DOMContentLoaded', function() {
  const cartIconBubble = document.querySelector('#cart-icon-bubble');
  const cartDrawer = document.querySelector('cart-drawer');
  
  // 只有在notification模式下才需要这个额外的处理
  // drawer模式下cart-drawer.js已经处理了
  if (cartIconBubble && cartDrawer && cartIconBubble.getAttribute('href') === '#') {
    cartIconBubble.addEventListener('click', function(event) {
      event.preventDefault();
      
      // 触发购物车抽屉打开
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open(cartIconBubble);
      }
    });
    
    // 为可访问性添加键盘支持
    cartIconBubble.addEventListener('keydown', function(event) {
      if (event.code.toUpperCase() === 'SPACE' || event.code.toUpperCase() === 'ENTER') {
        event.preventDefault();
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open(cartIconBubble);
        }
      }
    });
    
    // 设置可访问性属性
    cartIconBubble.setAttribute('role', 'button');
    cartIconBubble.setAttribute('aria-haspopup', 'dialog');
  }
});
